import '../sass/standard-hero.scss';
